<template>
  <div class="about container">
    <h1 class='title'>Page Not Found</h1>
    <h2 class="subtitle left"><br>
      The requested URL was not found on this server.
      Please try <router-link to="/">
      this link
    </router-link> to go home.
</h2>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
      msg: 'Welcome to the OOSH Zone!',
      stjustins: {
        name: 'St Justin’s Catholic Primary School',
        phone: '0425213083',
        times: {
          morning: '6:45am - 8:30am',
          afternoon: '3:30pm - 6:30pm',
          vacation: '7:30am - 5:30pm'
        }
      },
      stgregs: {
        name: 'St Gregory’s College Junior School',
        phone: '0467866256',
        times: {
          morning: '6:30am - 8:00am',
          afternoon: '3:30pm - 6:30pm',
          vacation: '6:30am - 6:30pm'
        }
      }
    }
  }
}
</script>

<style scoped>
.about {
  padding: 2em;
  padding-top: 60px;
}
.left {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/NotFoundComponent.vue